import StudentSchedule from '@/views/schedule/schedulePage.vue'

export default [
  {
    path: '/studentSchedule',
    name: 'Weekly Schedule',
    component: StudentSchedule,
    meta: {
      title: 'Weekly Schedule',
      requiresAuth: true,
      authorizedUsers: [1],
    },
  },
]
